// @flow

export const TOGGLE_WIDGET = 'TOGGLE_WIDGET'
export const SET_WIDGET = 'SET_WIDGET'

export const setWidget = name => ({ type: SET_WIDGET, name })
export const toggleWidget = name => ({ type: TOGGLE_WIDGET, name })
